import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable, inject, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Account } from '../../models/customer';
import { State } from '../../services/global-state';

@autoinject
export class PayInInstallmentReceipt {
	router: any;
	eventAggregator: any;
    paymentInformation: any;
	account: Account;
	bucketKey: number | null;

	constructor(private globalState: State, router: Router, eventAggregator: EventAggregator) {
		this.router = router;
		this.eventAggregator = eventAggregator;
	}
	activate(model, routeData) {
		this.account = this.globalState.accounts.find((element, index, array) => {
			return element.id === model.id;
		});
		this.bucketKey = this.account.bucket
			? this.account.bucket.bucketKey
			: this.account.bucketKey || null;
        this.paymentInformation = routeData.paymentInformation;
	}
	returnToDashboard() {
		this.router.navigateToRoute('dashboard');
	}
}